import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
const steps = ["Explore all six volumes", "Review the diagnostic workflows", "Examine the decision trees", "Use the case documentation templates", "Review the checklists and reference cards", "Decide whether the system adds practical value"];
export function Guarantee() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-138" data-mp="19dzcd0y31qa6">
      <div className="mx-auto max-w-3xl text-center" data-id="element-139" data-mp="19ceep2gh1r83">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-gold bg-night text-white" data-id="element-140" data-mp="14gz3yjdrgbfw">
          <ShieldCheckIcon className="h-9 w-9 text-gold" aria-hidden="true" data-id="element-141" data-mp="1j6dhm3oddf13" />
          <span className="mt-1 font-display text-2xl font-black leading-none" data-id="element-142" data-mp="1ecj0n805fe5p">7 DAYS</span>
        </div>
        <p className="mt-6 text-sm font-bold uppercase tracking-wider text-brand" data-id="element-143" data-mp="qm6i737a1z0v">Your 7-day money-back guarantee</p>
        <h2 className="mt-2 font-display text-[30px] font-extrabold leading-[1.1] text-ink sm:text-5xl" data-id="element-144" data-mp="lnbylz1hk6fp">
          Try the Blueprint Without Risk
        </h2>
        <p className="mt-4 text-[17px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-145" data-mp="txbc02eme54y">
          I want you to be able to review the system and decide whether it fits the way you work. After purchasing,
          you can:
        </p>

        <ul className="mx-auto mt-6 grid max-w-xl gap-3 text-left sm:grid-cols-2" data-id="element-146" data-mp="12t0y6dnw73je">
          {steps.map(s => <li key={s} className="flex items-start gap-2 text-[16px] text-ink" data-id="element-147" data-mp="azqrf7iw1sq5">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-148" data-mp="b1utdjx88hns" />
              {s}
            </li>)}
        </ul>

        <p className="mt-6 text-[17px] leading-relaxed text-ink-soft" data-id="element-149" data-mp="k1htm2e7zhf9">
          If, within seven days of purchase, you decide the blueprint isn't right for you, contact us to request a
          refund under the applicable guarantee terms. <strong className="text-ink" data-id="element-150" data-mp="1vdr0popz73dl">No complicated explanation is required.</strong>
        </p>

        <div className="mt-10" data-id="element-151" data-mp="3rgx4uyy3ijhl">
          <CtaButton label="Get the Blueprint — risk-free" sublabel="Backed by a 7-day guarantee" data-id="element-152" data-mp="3nh53p7b17fm9" />
        </div>
      </div>
    </section>;
}